// extracted by mini-css-extract-plugin
export default {"countdown":"z0-z","srOnly":"A0-z"};